import { ENTER } from 'constants/keyboard';
import { KeyboardEvent } from 'react';

export const handlerEnter = (onSubmit: () => void) => (e: KeyboardEvent<HTMLButtonElement>) => {
  if (e.code === ENTER) {
    e.preventDefault();
    onSubmit();
  }
};
